/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionConfigTime
 */
export interface BidirectionalActionConfigTime {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    required: boolean;
    /**
     * 
     */
    required_if_date_provided?: boolean;
}

/**
 * Check if a given object implements the BidirectionalActionConfigTime interface.
 */
export function instanceOfBidirectionalActionConfigTime(value: object): value is BidirectionalActionConfigTime {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function BidirectionalActionConfigTimeFromJSON(json: any): BidirectionalActionConfigTime {
    return BidirectionalActionConfigTimeFromJSONTyped(json, false);
}

export function BidirectionalActionConfigTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigTime {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'required': json['required'],
        'required_if_date_provided': json['required_if_date_provided'] == null ? undefined : json['required_if_date_provided'],
    };
}

export function BidirectionalActionConfigTimeToJSON(json: any): BidirectionalActionConfigTime {
    return BidirectionalActionConfigTimeToJSONTyped(json, false);
}

export function BidirectionalActionConfigTimeToJSONTyped(value?: BidirectionalActionConfigTime | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'required': value['required'],
        'required_if_date_provided': value['required_if_date_provided'],
    };
}

